import AuthConfig from "./AuthConfig";

export default class AuthService {
  static registerAuthStateListener(callback){
    return AuthConfig.FirebaseConnector.onChangeAuth(callback)
  }

  static login(user) {
    return new Promise(async (resolve, reject) => {
      try{
        let userData = await AuthConfig.FirebaseConnector.login(user.email, user.password);
        resolve({...userData, app:["Nuevamente"]})
      } catch (e) {
        console.log("ERROR LOGIN",e)
        let error = {code:e.code, message: "No pudimos loguear el usuario ingresado"}
        if(e.code=="auth/invalid-password" || e.code=="auth/wrong-password" || e.code == "auth/user-not-found") {
          error.message = "Usuario y/o constraseña incorrectos" 
        }

        reject(error);
      }
    });
  }

  static logout(){
    return AuthConfig.FirebaseConnector.logout()
  }

  static createAccount(user, onSuccess, onFail) {
    AuthConfig.FirebaseConnector.createAccount(user, onSuccess, onFail);
  }

  static getToken() {
    return AuthConfig.FirebaseConnector.getToken();
  }

  // pega contra firebase (usa FirebaseConnector)
  // static forgotPassword(userEmail) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       let resp = AuthConfig.FirebaseConnector.forgotPassword(userEmail);
  //       resolve(resp);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }

  // static confirmPasswordReset(code, password) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       let resp = AuthConfig.FirebaseConnector.confirmPasswordReset(
  //         code,
  //         password
  //       );
  //       resolve(resp);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }
}




// WEBPACK FOOTER //
// ./src/provider/auth/AuthService.js